import { BackendModel, BackendService } from '../../core/backend.service';

export class Color extends BackendModel {

  static path = '/productos/colores/';

  id: number;
  description: string;
  code: string;
  
  colorSeleccionado: boolean;
  
  constructor(protected backendService: BackendService, model?: Color) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/color/color.model.ts